const payloadItemAction = {
  ADD: 1,
  DELETE: 2,
  UPDATE: 3,
};

const transporterPaymentAction = {
  LIST: 1,
  UPDATE: 2,
  BULK_UPDATE: 3,
  INDENT_ATTACHMENTS: 4,
  EXCEL_DOWNLOAD: 5,
  INDENT_DETAILS: 6,
  DELETE_ATTACHMENTS: 7,
  LIST_CHARGES: 8,
  COMMENT: 9,
  UPDATE_EXTRA_KM_CHARGE: 10,
  CREATE_DEDICATED_TRUCK_MIN_GUARANTEE_PAYMENT: 11,
  DEBIT_ADJUSTMENT: 12,
  FREIGHT_BILL_PAYMENT_CHARGES: 13,
  GET_PAYMENT_CHARGE: 14,
  LIST_CHARGES_META: 15,
  COMMENT_ATTACHMENTS: 16,
  CHARGE_DETAILS: 17,
  CHARGE_COMMENT: 18,
  LIST_PAYMENTS: 19,
  TRANSIT_PENALTY: 20,
};

const ShipperPaymentAction = {
  INDENT_DETAILS: 1,
  COMMENT: 2,
  INDENT_ATTACHMENTS: 3,
  DELETE_ATTACHMENTS: 4,
  COMMENT_ATTACHMENTS: 5,
  CHARGE_DETAILS: 6,
};

const TruckAssignActionType = {
  ASSIGN_TRUCK: 'ASSIGN_TRUCK',
  SHIPPER_UPDATE_TRUCK: 'SHIPPER_UPDATE_TRUCK',
  TRANSPORTER_UPDATE_TRUCK: 'TRANSPORTER_UPDATE_TRUCK',
};

const transporterInvoiceAction = {
  LIST: 1,
  CREATE: 2,
  SHOW: 3,
  COMMENT: 4,
  STATUS_UPDATE: 5,
  UPDATE: 6,
  PRINT: 7,
  EXPORT: 8,
  CANCEL: 9,
  DISCOUNT: 10,
  MAIL_ANNEXURE: 11,
  PRINT_ANNEXURE: 12,
  SHOW_DETAIL: 13,
  VERIFY: 14,
};

const shipperInvoiceAction = {
  LIST: 1,
  SHOW_DETAIL: 2,
  COMMENT: 3,
  SHOW: 4,
  STATUS_UPDATE: 5,
  UPDATE: 6,
  PRINT: 7,
  ERP_STATUS: 8,
  EXPORT: 9,
  MULTI_INVOICE_ERP_STATUS: 10,
  FREIGHT_BILL_EXPORT: 11,
  CANCEL_INVOICES: 12,
  GET_PAYMENT_CHARGE: 13,
  SIGNATURE_STATUS_UPDATE: 14,
  MAIL_ANNEXURE: 15,
  PRINT_ANNEXURE: 16,
  VERIFY: 17,
};

const transporterWalletAction = {
  LIST: 1,
  EXPORT: 2,
  STATUS: 3,
  COMMENT: 4,
};

const shipperWalletAction = {
  LIST: 1,
  EXPORT: 2,
  UPDATE: 3,
  STATUS: 4,
  COMMENT: 5,
};

const transporterFreightBillAction = {
  LIST: 1,
  PRINT: 2,
  EXPORT: 3,
};

const commonAttachmentAction = {
  ADD: 1,
  DELETE: 2,
};

module.exports = {
  payloadItemAction,
  transporterPaymentAction,
  ShipperPaymentAction,
  transporterInvoiceAction,
  shipperInvoiceAction,
  transporterWalletAction,
  shipperWalletAction,
  transporterFreightBillAction,
  commonAttachmentAction,
  TruckAssignActionType,
};
